import { FormGroup } from '@angular/forms';
import { FormService } from './components/form/form.service';
import { ActivatedRoute } from '@angular/router';

export default class BaseDecorator {
    public form: FormGroup;
    public formService: FormService;
    public route: ActivatedRoute;
    public data: any;
    public form_data: any;
    public action: any;
    public className: String;
    public injector: any;

    constructor(route: ActivatedRoute, name: String, injector?) {
        this.route = route;
        this.className = name;
        this.injector = injector ? injector : null;
    }

    setData(formService: FormService, data: any, customButton: any, saveButton?: any) {
        this.formService = formService;
        this.data = data;
    }

    setFormGridData(data: any, customButton: any, saveButton?: any) {
        this.form_data = data;
    }

    init() {
        console.log("Decorator Init");
    }
    setForm(form: any, action: any = "ADD") {
        this.form = form;
        this.action = action;
    }
    destroy() {
        console.log("Destroy");
    }
    valueChangeStart(e: any, formObj: any = false) {
        console.log("valueChangeStart ", e);
    }
    valueChangeEnd(e: any, formObj: any = false) {
        console.log("valueChangeEnd ", e);
    }
    /*****
      IF THIS FUNCTION RETURNS FALSE, further validation will not be checked 
    *****/
    beforeSubmitValidation(obj?,cb?): any {
        if (cb != undefined && cb) {
            cb(true);
        }
        else {
            return true;
        }
    }

    /*****
    IF THIS FUNCTION RETURNS FALSE, form object will not be emmited
  *****/
    beforeOnSubmit(result: any, currentBtnVal: any): Boolean {
        console.log("beforeOnSubmit ", result);
        return true;
    }
    optionChanged(question) {
        console.log("optionChanged ", question);
    }
    beforeSubmitRequest(object, data?) {
        console.log("beforeSubmitRequest ", object);
    }

    // this function is used to submit data inside decorator
    submitInsideDecorator(object,callback?): Boolean {
        if(callback){
            callback(false)
        };
        console.log("submitInsideDecorator ", object);
        return false;
    }
    // getButtonData(data) {
    //     console.log("getButtonData ", data);
    // }

    afterGetRequestFilterSuccess(object, data,currentBtnVal?:any) {
        console.log("afterGetRequestFilterSuccess ", object, "data",data);
    }

    /*****
      IF THIS FUNCTION RETURNS FALSE, UI-ENGINE redirection and further logic will not fire and you will have the full control 
    *****/
    afterSubmitReqSuccess(event, response, formComponent): Boolean {
        console.log("afterSubmitReqSuccess ", event, response, formComponent);
        return true;
    }
    /*****
      THIS FUNCTION works in the case of editable grid when value change starts
    *****/
    valueChangeStartEG(e: any, formObj: any = false) {
        console.log("valueChangeStart ", e);
    }
    valueChangeEndEG(e: any, formObj: any = false) {
        console.log("valueChangeStart ", e);
    }
    listenChangeEventEG(obj: any, editable: any) {
        console.log("listen change");
    }
    afterSubmitReqError(event, data, formComponenet) {
        console.log("after submit error", event);
        // return true
    }
    beforeOnSubmitEG(result: any, value: any): Boolean {
        console.log("beforeOnSubmitEG ", result);
        return true;
    }
    afterErrorRequest(result:any, data:any){
        return true;
    }
    //this works to set dropdowns in case of editable grids
    setDropdownEG(e: any, index) {

    }

    QrCodeSacnnedStart(result: any, formObj: any) {
        console.log("result is :: ", result); //if user not bale to save data in the form want to perform some action
    }
    //this works for capability click of grid via ui engine
    capabilityClick(menuObj, callback?) {
        console.log("menuObj is as::", menuObj);
        if(callback != undefined && callback){
            callback(true);
        }
    }
    // this works to show/hide grid buttons 
    showAndHideGridButton(buttonList, callback) {
        callback(buttonList);
    }
    // If want to add any parameter on bind Grid in list
    bindGridExtended(gridData, resource, application, callback){
        callback({"gridData":gridData, "resource":resource, "application":application});
    }
    // this works in case of complex search
    complexSearchManipulation(search_data, callback?) {
        console.log("search data is ::", search_data);
        if(callback != undefined && callback)
            callback(search_data);
        else
            return search_data;
    }

    filtersOnSubmitEG(filter:any, editableGrid: any): Boolean{
        console.log("filtersOnSubmitEG ::", filter + " editable grid ::", editableGrid);
        return true;
    }

    confirmBeforeSubmit(data: any, action: any){
        console.log("ConfirmBeforeSubmi ::", data + " Action ::", action);
        return true;
    }

    processResourceDef(resourceDef){
        return resourceDef;
    }
    bannerEvents(event){}
    processDataList(currentData,dataList,callback){
        callback(dataList);
    }
    processFieldsList(data,callback){
        callback(data.currentListFields);
    }
    processDataGridConfig(config, callback){
        callback(config);
    }
    processFilter(event,currentData){
        return event;
    }
    // manipulateCompositeArrayRowAddition(item, obj){
    //     console.log("manipulateCompositeArrayRowAddition called");
    //     return true;
    // }
    onItemClickedDecorator(data, settings, index){
        console.log("Data is as::", data + ", Settings are as::", settings + ", Index is as::", index);
    }
    processBulkAction(action, selectedItems?, items?, selectedIndices?, cb?) {
        console.log("Action  is ::", action + ", Selected Items are ::", selectedItems + ", Items are ::", items + ", Selected Indices are ::"+selectedIndices);
        if (cb != undefined && cb) {
            cb(true);
        } else {
            return true;
        }
    }
    backNavigationClick() {
        console.log("Back Navigation Clicked !");
    }
    manipulateCompositeArrayRow(callback){
        callback(true);
    }
    //added support for multiselect dropdown close event
    onMultiSelectClose(formObj?: any) {
        //console.log("Multiselect closed !");  
      }

    barcodeKeydownListener (event: KeyboardEvent) {
        throw new Error('Method not implemented.');
    }

    resetDefault(fields){
        return fields;
    }
}